import { render, staticRenderFns } from "./BundleItem.vue?vue&type=template&id=4b79519b&scoped=true&"
import script from "./BundleItem.vue?vue&type=script&lang=js&"
export * from "./BundleItem.vue?vue&type=script&lang=js&"
import style0 from "./BundleItem.vue?vue&type=style&index=0&id=4b79519b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b79519b",
  null
  
)

export default component.exports